<template>
  <div class="upload-input-cover">
    <input type="file" :accept="accept" mutiple="mutiple" class="upload-input" @input="updateImage" :disabled="disabled" />
    <img src="../assets/image/patient_upload.png" alt="" srcset="" v-show="value === ''">
    <img :src="value" alt="" srcset="" v-show="value !== ''">
    <img src="../assets/image/upload_load_circle.png" alt="" class="loading" v-show="loading">
    <div class="mask" v-if="disabled"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { showNotify } from 'vant';
export default {
  name: 'upload',
  data () {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'orderDetail'])
  },
  props: {
    // 限制上传的文件格式
    accept: {
      type: String,
      default: ''
    },
    // 展示图片的url
    value: {
      type: String,
      default: ''
    },
    // 禁止点击
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否展示选择中的图片
    choose: {
      type: Boolean,
      default: false
    },
    // 当多个上传同时出现
    // 设置每一个上传组件的id
    // 帮助上传文件成功后，对应数据绑定文件
    identifier: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '5M'
    }
  },
  methods: {
    async upload (file) {
      let formData = new FormData()
      formData.append('systemCode', 'TMC');
      formData.append('belongCode', 'CONTENT');
      formData.append('belongID', this.userInfo.orderID || this.orderDetail.inquiryOrderID);
      formData.append('file', file);
      let remoteAddress = ''
      await this.$_http.post(this.$_API.TMC_POST_UPLOAD_FILE, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data) {
          remoteAddress = res.data.remoteAddress
        }
      });
      return remoteAddress
    },
    async updateImage (event) {
      let { files } = event.currentTarget;
      if (files.length === 0) {
        return false;
      }
      let type = files[0].type.split('/')[0]
      let byteSize = 0
      if (this.size.indexOf('G') !== -1) {
        byteSize = parseInt(this.size.split('G')[0]) * 1024 * 1024 * 1024
      } else if (this.size.indexOf('M') !== -1) {
        byteSize = parseInt(this.size.split('M')[0]) * 1024 * 1024
      } else if (this.size.indexOf('KB') !== -1) {
        byteSize = parseInt(this.size.split('KB')[0]) * 1024
      }
      switch (type) {
        case 'image':
          if (files[0].size >= byteSize) {
            showNotify({
              type: 'warning',
              message: `请上传${this.size}以内的图片`,
              duration: 1000
            });
            return false;
          }
          break;
        case 'video':
          break;
        default:
          break;
      }
      let blob = new Blob([files[0]]);
      this.$emit('updateImage', { files, id: this.identifier, type });
      if (!this.choose) {
        this.$emit('update:value', window.URL.createObjectURL(blob))
        this.loading = true
        this.$bus.emit('updateSuccess', {
          id: this.identifier,
          flag: false
        })
        let remoteAddress = await this.upload(files[0])
        this.loading = false
        this.$bus.emit('updateSuccess', {
          id: this.identifier,
          flag: true
        })
        this.$emit('update:value', remoteAddress)
      }
    }
  }
};
</script>

<style scoped>
.upload-input-cover {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-input {
  opacity: 0;
  z-index: 9;
  height: 100%;
  width: 140%;
  position: absolute;
}

.upload-input-cover > img {
  max-height: 24px;
  max-width: 24px;
  z-index: 8;
}

.mask {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 99;
  background-color: #00000060;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loading /* Safari 与 Chrome */ {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading {
  height: 50%;
  width: 50%;
  position: absolute;
  animation: loading 0.4s;
  animation-iteration-count: infinite;
}
</style>
